import { useEffect, useRef, useState } from "react";
import "./Input.css";
import CurrencyInput from "react-currency-input-field";

const Input = ({
  defaultValue,
  multiLine,
  style,
  isSelect,
  label,
  value,
  placeholder,
  onChange,
  required,
  hideErrorLabel,
  disabled,
  error,
  name,
  centerLabel,
  fixedLabel,
  hideWhenDisabled,
  isNumeric = false,
  disableAutocomplete = true,
  upperCase,
  limit,
  preFillValue,
  isFlightHours = false,
  allowDecimals = true,
  minValue,
  prefix,
  suffix,
  suffixIcon,
  onSuffixIconClick,
  localizedFormat,
  format = true,
  isPercentage = false,
  ...props
}) => {
  const [errorState, setErrorState] = useState(error);
  const [touched, setTouched] = useState(false);
  const inputRef = useRef(null);
  const locale = 'en-Us';
  const addCommas = (num) => {
    if (num === null || num === undefined || num === "") return "";
    if (!format) return num.toString();

    const parsedNum = Number(num);
    if (isNaN(parsedNum)) return num.toString();
    return numberFormatter.format(parsedNum);
  };
  const numberFormatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: allowDecimals ? 0 : 0,
    maximumFractionDigits: allowDecimals ? 2 : 0,
  });
  const getSeparators = () => {
    const parts = numberFormatter.formatToParts(1234.5);
    const decimal = parts.find((p) => p.type === "decimal")?.value || ".";
    const group = parts.find((p) => p.type === "group")?.value || ",";
    return { decimal, group };
  };

  const separators = getSeparators();
  const removeNonNumeric = (num) => {
    const { decimal, group } = separators;

    const cleaned = num.replace(new RegExp(`\\${group}`, "g"), "");

    const normalized = cleaned.replace(decimal, ".");

    let result = normalized.replace(/[^0-9.]/g, "");

    if (allowDecimals) {
      const parts = result.split(".");
      if (parts.length > 2) {
        result = parts[0] + "." + parts.slice(1).join("");
      }
    }

    return result;
  };

  const [displayValue, setDisplayValue] = useState(
    value ? addCommas(value) : ""
  );

  const sanitizeFlightHours = (str) => {
    return str
      .toString()
      .replace(/[^0-9:]/g, "")
      .replace(/:{2,}/g, ":");
  };

  useEffect(() => {
    setErrorState(error || (touched && required && !value ? "Required" : ""));
  }, [value, required, error, touched]);

  useEffect(() => { }, [disabled]);

  const formatDisplayValue = (num) => {
    if (num === null || num === undefined || num === "") return "";

    let valueStr = addCommas(num);

    if (prefix) valueStr = `${prefix}${valueStr}`;
    if (suffix) valueStr = `${valueStr}${suffix}`;
    if (isPercentage) valueStr = `${valueStr}%`;

    return valueStr;
  };

  useEffect(() => {
    if (isNumeric && value !== undefined && value !== null) {
      const formatedValue = formatDisplayValue(value);
      setDisplayValue(formatedValue);
    }
  }, [value, prefix, suffix, isPercentage]);

  const handleFlightHoursChange = (event) => {
    const rawValue = event.target.value;
    let cleanValue = sanitizeFlightHours(rawValue);

    const parts = cleanValue.split(":");
    if (parts.length > 2) {
      cleanValue = parts.slice(0, 2).join(":");
    }

    onChange && onChange({ target: { name, value: cleanValue } });
  };

  const handleNumericChange = (event) => {
    const input = event.target;
    const cursorPosition = input.selectionStart;

    let rawValue = input.value;
    if (prefix) rawValue = rawValue.replace(prefix, "");
    if (suffix) rawValue = rawValue.replace(suffix, "");
    if (isPercentage) rawValue = rawValue.replace("%", "");

    let numericValue = removeNonNumeric(rawValue);
    if (limit !== undefined && Number(numericValue) > Number(limit)) {
      numericValue = limit.toString();
    }

    onChange?.({ target: { name, value: numericValue } });

    // 👇 Restaurar el cursor al lugar original (1 ciclo después del re-render)
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 0);
  };


  const handleInputChange = (e) => {
    if (isFlightHours) {
      handleFlightHoursChange(e);
    } else if (isNumeric) {

      handleNumericChange(e);
    } else {
      if (upperCase) {
        onChange?.({
          ...e,
          target: {
            ...e.target,
            value: e.target.value.toUpperCase(),
            name: e.target.name,
          },
        });
      } else {
        onChange?.(e);
      }
    }
    // isNumeric ?  : (upperCase ? onChange?.({...e, target:{...e.target, value: e.target.value.toUpperCase()}}) :onChange)
  };

  const handleBlur = () => {
    setTouched(true);
    hasSelectedRef.current = false;
    if (isNumeric && minValue !== undefined && value !== undefined) {
      const numericValue = Number(value);
      if (numericValue < minValue) {
        onChange?.({ target: { name, value: minValue.toString() } });
      }
    }
  };
  const hasSelectedRef = useRef(false);
  const handleFocus = (e) => {
    if (!hasSelectedRef.current) {
      e.target.select();
      hasSelectedRef.current = true;
    }
  };



  return (
    !(disabled && hideWhenDisabled) && (
      <span className="input-component" style={style}>
        {multiLine ? (
          <textarea
            disabled={disabled}
            name={name}
            ref={inputRef}
            onBlur={handleBlur}
            value={value ?? undefined}
            className={`${label ? "" : "keep-placeholder"} ${errorState && !disabled ? "error" : ""
              } ${isSelect ? "select" : ""}`}
            onChange={onChange}
            onFocus={handleFocus}
            placeholder={placeholder ?? ""}
            {...props}
          ></textarea>
        ) : (
          localizedFormat ?
            <CurrencyInput
              disabled={disabled}
              name={name}
              ref={inputRef}
              onBlur={handleBlur}
              value={value}
              // value={isNumeric ? displayValue : value ?? undefined}
              defaultValue={preFillValue}
              // type="text"
              onFocus={handleFocus}
              className={`${label ? "" : "keep-placeholder"} ${errorState && !disabled ? "error" : ""
                } ${isSelect ? "select" : ""} ${isNumeric && format ? "numeric-field" : ""} ${upperCase ? "uppercase" : ""
                } ${suffixIcon ? "withIcon" : ""}`}
              onValueChange={(value) => onChange?.({ target: { name, value } })}
              autoComplete={disableAutocomplete ? "off" : "on"}
              placeholder={placeholder ?? ""}
              {...props}
            />
            :
            <input
              disabled={disabled}
              name={name}
              ref={inputRef}
              onBlur={handleBlur}
              value={isNumeric ? displayValue : value ?? undefined}
              defaultValue={preFillValue}
              type="text"
              onFocus={handleFocus}
              className={`${label ? "" : "keep-placeholder"} ${errorState && !disabled ? "error" : ""
                } ${isSelect ? "select" : ""} ${isNumeric && format ? "numeric-field" : ""} ${upperCase ? "uppercase" : ""
                } ${suffixIcon ? "withIcon" : ""}`}
              onChange={handleInputChange}
              autoComplete={disableAutocomplete ? "off" : "on"}
              placeholder={placeholder ?? ""}
              {...props}
            />
        )}
        {label && (
          <label
            className={`${centerLabel ? "centered" : ""} ${fixedLabel ? "fixed" : ""
              }`}
          >
            {`${required ? "*" : ""}${label}`}
          </label>
        )}
        {errorState && !disabled && !hideErrorLabel && (
          <span className="error-tag">{errorState}</span>
        )}
        {suffix && <b className="input-suffix">{suffix}</b>}
        {suffixIcon && (
          <i
            onClick={onSuffixIconClick}
            className={`${suffixIcon} suffixIcon`}
          ></i>
        )}
      </span>
    )
  );
};

export default Input;
